<template>
<div class="prices">
  <!-- <ui-loader v-model="loading" ref="loader" /> -->
   <v-dialog
      v-model="confirmDialog"
      hide-overlay
      persistent
      width="300"
    >
      <v-form v-on:submit.prevent="saveLists" v-model="valid" ref="changePasswordForm">
        <v-card
          color="error"
          dark
        >
          <v-card-text>
            <h3>Atención</h3>
            Al realizar modificaciones a las listas de precios
            los usuarios serán redirigidos a la pantalla de login
            para volver a iniciar sesion. El usuario actual no terminara
            su sesion, por lo cual es necesario volver a iniciarla para
            ver los cambios reflejados
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="confirmDialog = false">Cancelar</v-btn>
            <v-btn type="submit" color="success">Actualizar</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  <v-container>
    <v-layout wrap>
      <v-flex>
        <v-card>
          <v-card-title primary-title>
            <h1>Listas</h1>
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs4 class="title">
                Nombre
              </v-flex>
              <v-flex xs1></v-flex>
              <v-flex xs2 class="title">
                Porcentaje
              </v-flex>
              <v-flex xs1></v-flex>
              <v-flex xs3 class="title">
                Color
              </v-flex>
              <v-flex xs1 class="text-xs-center ">

              </v-flex>
            </v-layout>
            <v-divider mb-2></v-divider>
            <v-layout row wrap mb-2>
            </v-layout>
            <v-layout row wrap v-for="list in lists" :key="list.id">
              <v-flex xs4>
                <v-text-field name="name" :solo="solo" v-model="list.name"></v-text-field>
              </v-flex>
              <v-flex xs1></v-flex>
              <v-flex xs2>
                <v-text-field name="name" :solo="solo" v-model="list.percentage"></v-text-field>
              </v-flex>
              <v-flex xs1></v-flex>
              <v-flex xs3>
                <v-text-field name="color" :solo="solo" v-model="list.color">
                </v-text-field>
              </v-flex>
              <v-flex xs1 class="text-xs-center ">
                <v-chip :color="list.color"></v-chip>
              </v-flex>
            </v-layout>
            <v-layout row wrap mb-12>
              <v-icon  @click="dialogList = true">post_add</v-icon>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              type="submit"
              :class=" { 'blue-grey darken-2 white--text' : valid, disabled: !valid }"
              @click.stop="confirmDialog = true">Guardar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <v-flex xs1>
      <v-dialog v-model="dialogList" max-width="500px">
        <!-- <v-btn slot="activator" color="blue-grey darken-2 white--text" dark class="mb-2">Nuevo</v-btn> -->
        <v-form v-model="valid">
        <v-card>
          <v-card-title primary-title>
            <h1>Nueva Lista</h1>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm12>
                  <v-text-field v-model="list.name"
                  prepend-inner-icon="list"
                  label="Nombre" :rules="required" :solo="solo"></v-text-field>
                </v-flex>
                <v-flex xs12 sm12>
                  <v-text-field type="number" v-model="list.percentage"
                  prepend-inner-icon="percent" :rules="numberP"
                  label="Porcentaje"  :solo="solo"></v-text-field>
                </v-flex>
                <v-flex xs12 sm12>
                  <v-text-field
                    v-model="list.color"
                    type="color"
                    prepend-inner-icon="palette"
                    label="Código color"
                    :solo="solo"></v-text-field>
                </v-flex>
               
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="close">Cancelar</v-btn>
            <v-btn color="success" @click="saveNewList" :disabled="!valid">Guardar</v-btn>
          </v-card-actions>
        </v-card>
        </v-form>
      </v-dialog>
    </v-flex>
  </v-container>
</div>
</template>

<script>
export default {
  name: 'Prices',
  data() {
    return {
      solo: true,
      valid: false,
      lists: [],
      loading: false,
      confirmDialog: false,
      // valid: true,
      dialogList: false,
      list:{
        color:'',
        name:'',
        percentage:''
      },
      required: [
        (v) => !!v || 'Campo requerido',
      ],
      numberP: [
        (v) => Number.isInteger(Number(v)) || "Ingrese solo numeros",
      ],
    };
  },

  async created() {
    const lists = await this.axios.get('/catalogs/priceCategory');
    this.lists = lists.data;
  },

  methods: {
     saveLists() {
      this.axios.put('/catalogs/priceCategory', this.lists)
        .then((results) => {
          this.$emit('success', 'Listas actualizadas');
          this.confirmDialog = false;
        })
        .catch((err) => {
          this.$emit('error', error);
        });
    },
    saveNewList() {
      this.axios.post('/catalogs/priceCategory', this.list)
        .then((results) => {
          this.$emit('success', 'Lista agregada correctamente');
          this.dialogList = false;
        })
        .catch((err) => {
          this.$emit('error', error);
      });
    },
    close() {
      this.dialogList = false;
     
    },
  },
};
</script>
